export const FormRow = (props: {
  children: React.ReactNode;
  className?: string;
  padding?: string;
}) => {
  const { children, className, padding } = props;
  return (
    <div
      className={`c-form-row ${className ?? "row g-0"} py-${padding ?? "5"}`}
    >
      {children}
    </div>
  );
};

export const FormRowLabel = (props: {
  children: React.ReactNode;
  section: string;
  htmlFor?: string;
  className?: string;
  column?: string;
  radioHeading?: boolean;
}) => {
  const { children, section, htmlFor, className, column, radioHeading } = props;
  return (
    <div
      className={`d-flex gap-3${className ? ` ${className}` : ""}${
        column ? ` ${column}` : " col-8"
      }`}
    >
      <h5 className="fw-normal flex-shrink-0 lh-base">{section}</h5>
      {radioHeading ? (
        <p className="form-label mb-0 me-3">{children}</p>
      ) : (
        <label className="form-label mb-0 me-3" htmlFor={htmlFor}>
          {children}
        </label>
      )}
    </div>
  );
};

export const FormRowInput = (props: {
  children: React.ReactNode;
  className?: string;
  column?: string;
}) => {
  const { children, className, column } = props;
  return (
    <div
      className={`${className ? ` ${className}` : ""}${
        column ? ` ${column}` : " col-4"
      }`}
    >
      {children}
    </div>
  );
};
